import { leaveDetailList } from './../../constants/constants';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/retry';
import 'rxjs/add/observable/zip';
import 'rxjs/add/operator/concat';
import 'rxjs/add/observable/from'
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/first';

import * as firebaseApp from 'firebase/app';

/*
* Firebase Service
* 
* Gestione binding firebase con manipolazione dati ricevuti
* Gestione Endpoint per ricerca
*
*/

import { User } from '../../model/user';
import { Week } from './../../model/Week';
import { usersEndpointRoot, usersEndpoint, secretaryDelegation } from '../../constants/constants';
import { Subscription } from 'rxjs/Subscription';

/*
  Generated class for the FirebaseServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/

@Injectable()
export class FirebaseServiceProvider {

  private idToken: string;

  private week_subscription: Subscription = null;
  private currentWeeks: BehaviorSubject<Week[]>;

  private weeks: Week[] = [];
  private currentModWeek: BehaviorSubject<Week>; //binding per visualizzazione

  private Users: User[] = []; //Lista utenti
  private usersManager: User[] = [];
  private usersAreaManager: User[] = [];
  private usersAreaManager_Manager: User[] = [];
  private userAD: User[] = [];

  private userWeekSubscription: Subscription;

  constructor(
    private autenticazione: AngularFireAuth,
    private adb: AngularFireDatabase) {

    this.currentWeeks = new BehaviorSubject<Week[]>([]);
    this.currentModWeek = new BehaviorSubject<Week>(null);

  }

  /**
   * Funzione per restituire il provider google
   */
  getProviderGoogle(): any {
    return new firebaseApp.auth.GoogleAuthProvider();
  }

  /**
   * Restitusce il servizion di autenticazione per essere usato nel core service
   */
  getAuthService(): AngularFireAuth {
    return this.autenticazione;
  }

  /**
   * Controlla lo stato di autenticazione e richiede il token da firebase
   */
  auth(): Observable<boolean> {
    return Observable.create(obeserver => {

      this.autenticazione.authState.subscribe(auth => {

        if (auth) {
          auth.getIdToken().then(token => {
            this.idToken = token;
            //console.log('token');
            //console.log(token);

            this.refreshTokenAuto();

            obeserver.next(true);

          }).catch(err => {

            obeserver.next(false);
            //console.log(err);
          });
        } else {
          //console.log('richiedere autenticazione');

          obeserver.next(false);
        }
      });

    });
  }

  /**
   * Scarica configurazione dal server
   */
  getConfiguration(): Promise<any> {
    let configEndpoint = this.adb.object('/configuration');

    let promise = configEndpoint.valueChanges().first().toPromise();

    return promise;
  }

  /**
   * Refresh token firebase
   */
  refreshTokenAuto() {
    this.autenticazione.idToken.subscribe(change => {
      this.idToken = change;
    });
  }

  /**
   * Restituisce il token firebase
   */
  getToken(): string {
    return this.idToken;
  }

  private generateNotesKeys(): string[] {
    return [
      "1_am_note",
      "1_pm_note",
      "2_am_note",
      "2_pm_note",
      "3_am_note",
      "3_pm_note",
      "4_am_note",
      "4_pm_note",
      "5_am_note",
      "5_pm_note",
      "6_am_note",
      "6_pm_note",
      "7_am_note",
      "7_pm_note"
    ];
  }

  /**
   * Genere l'oggetto settimana inserendo i dati utente
   * @param baseweek 
   */
  private generateWeek(baseweek: any): Week {

    // console.log(baseweek.payload.val());

    /*let tempWeek: Week = {
      ["1"]: baseweek.payload.val()["1"],
      ["2"]: baseweek.payload.val()["2"],
      ["3"]: baseweek.payload.val()["3"],
      ["4"]: baseweek.payload.val()["4"],
      ["5"]: baseweek.payload.val()["5"],
      ["6"]: baseweek.payload.val()["6"],
      ["7"]: baseweek.payload.val()["7"]
    };*/

    let tempWeek: Week = {
      ["1_am"]: baseweek.payload.val()["1_am"],
      ["1_pm"]: baseweek.payload.val()["1_pm"],
      ["2_am"]: baseweek.payload.val()["2_am"],
      ["2_pm"]: baseweek.payload.val()["2_pm"],
      ["3_am"]: baseweek.payload.val()["3_am"],
      ["3_pm"]: baseweek.payload.val()["3_pm"],
      ["4_am"]: baseweek.payload.val()["4_am"],
      ["4_pm"]: baseweek.payload.val()["4_pm"],
      ["5_am"]: baseweek.payload.val()["5_am"],
      ["5_pm"]: baseweek.payload.val()["5_pm"],
      ["6_am"]: baseweek.payload.val()["6_am"],
      ["6_pm"]: baseweek.payload.val()["6_pm"],
      ["7_am"]: baseweek.payload.val()["7_am"],
      ["7_pm"]: baseweek.payload.val()["7_pm"],
      show: false
    };

    for (let key of this.generateNotesKeys()) {
      if (baseweek.payload.val()[key])
        tempWeek[key] = baseweek.payload.val()[key];
    }

    for (let user of this.usersAreaManager) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    for (let user of this.usersAreaManager_Manager) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    for (let user of this.usersManager) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    for (let user of this.userAD) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    //Settaggio utente non presente nell'insieme
    if (!tempWeek.user) {
      tempWeek.user = {
        name: '',
        key: '',
        title: '',
        photo: '',
      }
    }

    if (baseweek.payload.val().confirmed)
      tempWeek.confirmed = baseweek.payload.val().confirmed;

    if (baseweek.payload.val().confirm_msg)
      tempWeek.confirm_msg = baseweek.payload.val().confirm_msg;

    if (baseweek.payload.val().last_modified_by)
      tempWeek.last_modified_by = baseweek.payload.val().last_modified_by;

    if (baseweek.payload.val().last_modified_timestamp)
      tempWeek.last_modified_timestamp = baseweek.payload.val().last_modified_timestamp;

    // console.log(tempWeek);

    return tempWeek;
  }

  /**
   * Genere l'oggetto settimana inserendo i dati utente
   * @param baseweek 
   */
  private generateFilterWeek(baseweek: any, leaveLabel: any): Week {

    let tempWeek: Week = {
      ["1_am"]: leaveLabel.indexOf(baseweek.payload.val()["1_am"]) > -1 ? 'Leave' : baseweek.payload.val()["1_am"],
      ["1_pm"]: leaveLabel.indexOf(baseweek.payload.val()["1_pm"]) > -1 ? 'Leave' : baseweek.payload.val()["1_pm"],
      ["2_am"]: leaveLabel.indexOf(baseweek.payload.val()["2_am"]) > -1 ? 'Leave' : baseweek.payload.val()["2_am"],
      ["2_pm"]: leaveLabel.indexOf(baseweek.payload.val()["2_pm"]) > -1 ? 'Leave' : baseweek.payload.val()["2_pm"],
      ["3_am"]: leaveLabel.indexOf(baseweek.payload.val()["3_am"]) > -1 ? 'Leave' : baseweek.payload.val()["3_am"],
      ["3_pm"]: leaveLabel.indexOf(baseweek.payload.val()["3_pm"]) > -1 ? 'Leave' : baseweek.payload.val()["3_pm"],
      ["4_am"]: leaveLabel.indexOf(baseweek.payload.val()["4_am"]) > -1 ? 'Leave' : baseweek.payload.val()["4_am"],
      ["4_pm"]: leaveLabel.indexOf(baseweek.payload.val()["4_pm"]) > -1 ? 'Leave' : baseweek.payload.val()["4_pm"],
      ["5_am"]: leaveLabel.indexOf(baseweek.payload.val()["5_am"]) > -1 ? 'Leave' : baseweek.payload.val()["5_am"],
      ["5_pm"]: leaveLabel.indexOf(baseweek.payload.val()["5_pm"]) > -1 ? 'Leave' : baseweek.payload.val()["5_pm"],
      ["6_am"]: leaveLabel.indexOf(baseweek.payload.val()["6_am"]) > -1 ? 'Leave' : baseweek.payload.val()["6_am"],
      ["6_pm"]: leaveLabel.indexOf(baseweek.payload.val()["6_pm"]) > -1 ? 'Leave' : baseweek.payload.val()["6_pm"],
      ["7_am"]: leaveLabel.indexOf(baseweek.payload.val()["7_am"]) > -1 ? 'Leave' : baseweek.payload.val()["7_am"],
      ["7_pm"]: leaveLabel.indexOf(baseweek.payload.val()["7_pm"]) > -1 ? 'Leave' : baseweek.payload.val()["7_pm"],
      show: false
    };

    for (let key of this.generateNotesKeys()) {
      if (baseweek.payload.val()[key])
        tempWeek[key] = baseweek.payload.val()[key];
    }

    for (let user of this.usersAreaManager) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    for (let user of this.usersAreaManager_Manager) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    for (let user of this.usersManager) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    for (let user of this.userAD) {
      if (user.key == baseweek.key) {
        //console.log(user);
        tempWeek.user = {
          name: user.name,
          key: user.key,
          title: user.title,
          photo: user.photo
        }
      }
    }

    //Settaggio utente non presente nell'insieme
    if (!tempWeek.user) {
      tempWeek.user = {
        name: '',
        key: '',
        title: '',
        photo: '',
      }
    }

    if (baseweek.payload.val().confirmed)
      tempWeek.confirmed = baseweek.payload.val().confirmed;

    if (baseweek.payload.val().confirm_msg)
      tempWeek.confirm_msg = baseweek.payload.val().confirm_msg;

    if (baseweek.payload.val().last_modified_by)
      tempWeek.last_modified_by = baseweek.payload.val().last_modified_by;

    if (baseweek.payload.val().last_modified_timestamp)
      tempWeek.last_modified_timestamp = baseweek.payload.val().last_modified_timestamp;

    // console.log(tempWeek);

    return tempWeek;
  }

  /**
   * Inizializza array utenti che possono essere visualizzati
   */
  setListUsers(users: User[]) {
    this.Users = [];

    for (let us of users)
      this.Users.push(us);
  }

  /**
   * Restituisce lista utenti filtrata
   */
  getListUsers(): User[] {
    return this.Users;
  }

  /**
   * Verifica esistenza settimana endpoint
   * @param endpoint 
   */
  getWeekExist(endpoint: string): Promise<boolean> {
    return new Promise(resolve => {
      this.adb.object(endpoint).valueChanges().first().subscribe(result => {
        //console.log(result);
        // console.log(userdata);
        if (result != null)
          resolve(true);
        else
          resolve(false);
      }, err => {
        //console.log(err);

        resolve(false);
      });
    });
  }

  /**
   * Ritorna array settimana corrente collegato a firebase
   */
  getWeeks(): BehaviorSubject<Week[]> {

    return this.currentWeeks;

  }

  /*array.sort((a: any, b: any) => {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    });*/

  /**
   * Aggiorna l'array settimana alla modifica su firebase
   * @param query_string 
   */
  getWeeksBinding(query_string: string, leaveFilter?: any, leaveLabel?: any): void {
    this.weeks = [];

    let usersRef: Observable<any>[] = [];
    for (let user of this.Users) {
      let temp = this.adb.object(query_string + user.key);
      usersRef.push(temp.snapshotChanges());

      /*let weektmp: Week = this.generateDays();*/
      let weektmp: Week = {
        show: false
      };

      weektmp.user = {
        name: user.name,
        title: user.title,
        key: user.key,
        photo: user.photo
      };

      // console.log(weektmp);
      this.weeks.push(weektmp);
    }

    if (this.week_subscription)
      this.week_subscription.unsubscribe();

    this.week_subscription = this.adb.list(query_string).snapshotChanges().subscribe(result => {
      for (let i in this.weeks)
        for (let week of result) {
          if (this.weeks[i].user.key == week.key) {

            if (leaveFilter) {
              if (leaveFilter.indexOf(this.weeks[i].user.key) == -1)
                this.weeks[i] = this.generateFilterWeek(week, leaveLabel);
              else
                this.weeks[i] = this.generateWeek(week);
            } else
              this.weeks[i] = this.generateWeek(week);

            break;
          }
        }

      this.currentWeeks.next(this.weeks);
    });

    /*
    for (let userOb of usersRef) {
      userOb.subscribe(week => {

        for (let i in this.weeks) {
          if (this.weeks[i].user.key == week.key) {
            this.weeks[i] = this.generateWeek(week);
            break;
          }
        }
        this.currentWeeks.next(this.weeks);
      });

    }
    */

  }

  /**
   * Genera il binding per aver i dati delle settimane precedenti e successive in cache firebase
   * @param query_string 
   */
  setOfflineWeeksBinding(query_string: string): void {
    //console.log('binding offline weeks');
    //console.log(query_string);
    let weekOffline = this.adb.list(query_string);

    weekOffline.snapshotChanges().subscribe(offlineweeks => {
      ////console.log(offlineweeks);
    });
  }

  disconnectWeek(): void {

    this.currentWeeks.next([]);
    this.currentModWeek.next(null);
    //Disconnect on exit?[]
  }

  /**
   * Controlla se la settimana precedente è stata confermata
   * @param endpoint 
   */
  getPreviousWeekConfirmed(endpoint: string): Observable<boolean> {
    let weekPreviousConfirmed = this.adb.object(endpoint);
    return new Observable<boolean>(resolve => {
      weekPreviousConfirmed.valueChanges().subscribe(confirmed => {

        if (confirmed)
          resolve.next(true);
        else
          resolve.next(false);
      });

    });

  }

  /**
   * Fornisce la settimana da modificare
   * @param userkey 
   */
  getWeek(userkey: string): BehaviorSubject<Week> {

    return this.currentModWeek;
  }

  /**
   * Fornisce il bindinga alla settimana da modificare
   * @param query_string 
   * @param userkey 
   */
  getWeekBinding(query_string: string, userkey: string): void {

    let weekOnline = this.adb.object(query_string + userkey);

    if (this.userWeekSubscription) {
      this.userWeekSubscription.unsubscribe();
    }

    this.userWeekSubscription = weekOnline.snapshotChanges().subscribe(onlineweek => {
      if (onlineweek.key != userkey) {
        this.currentModWeek.next(null);
      }
      else
        this.currentModWeek.next(this.generateWeek(onlineweek));
    });
  }

  /**
   * Restituisce la lista di utenze delegate
   * @param userkey 
   */
  getDelegations(userkey: string): Promise<any> {
    return new Promise(resolve => {
      this.adb.list(secretaryDelegation + '/' + userkey).snapshotChanges().first().subscribe(delegations => {

        resolve(delegations);
      }, err => {
        //console.log(err);

        resolve(false);
      });
    });
  }

  /**
  * Restituisce la lista di utenze leave detail visibili
  * @param userkey 
  */
  getLeaveDetailList(userkey: string): Promise<any> {
    return new Promise(resolve => {
      this.adb.list(leaveDetailList + '/' + userkey).valueChanges().first().subscribe(leaveDetails => {
        
        resolve(leaveDetails);
      }, err => {
        //console.log(err);

        resolve(false);
      });
    });
  }

  /**
   * Restituisce i dati dell'utente collegato all'endpoint
   * @param userendpoint 
   */
  getUser(userendpoint: string): Promise<any> {

    return new Promise(resolve => {
      this.adb.object(userendpoint).snapshotChanges().first().subscribe(userdata => {
        // //console.log(userdata);

        resolve(userdata);
      }, err => {
        //console.log(err);

        resolve(false);
      });
    });
  }

  /**
   * Restituisce tutti gli utenti
   * param userGroup (1 = areamanager, 2=manager)
   */
  getUsers(userGroup?: number): Promise<User[]> {

    let areaManager_ManagerPromise = this.getAreaManager_Manager();

    if (userGroup) {

      if (userGroup == 1) {
        let areaManagerPromise = this.getAreaManager();

        return new Promise(resolve => {
          Promise.all([areaManager_ManagerPromise, areaManagerPromise]).then(values => {

            let AllUsers = values[0].concat(values[1]);
            //console.log(AllUsers);
            //this.usersManager //this.usersAreaManager
            resolve(AllUsers);
          });
        });

      } else if (userGroup == 2) {
        let areaManagerPromise = this.getAreaManager();
        let managerPromise = this.getManager();

        return new Promise(resolve => {
          Promise.all([managerPromise, areaManager_ManagerPromise, areaManagerPromise]).then(values => {

            let temp = values[1].concat(values[2]);
            let AllUsers = values[0].concat(temp);

            //console.log(AllUsers);
            //this.usersManager //this.usersAreaManager
            resolve(AllUsers);
          });
        });
      }

    } else {

      let areaManagerPromise = this.getAreaManager();
      let managerPromise = this.getManager();
      let ADPromise = this.getADuser();

      return new Promise(resolve => {
        Promise.all([ADPromise, managerPromise, areaManager_ManagerPromise, areaManagerPromise]).then(values => {

          let temp = values[0].concat(values[1]);
          let temp_2 = values[2].concat(values[3]);
          let AllUsers = temp.concat(temp_2);

          //console.log(AllUsers);
          //this.usersManager //this.usersAreaManager
          resolve(AllUsers);
        });
      });

    }

  }

  getManager(): Promise<User[]> {

    let tempManagerRef = this.adb.list(usersEndpointRoot + usersEndpoint.manager);

    return new Promise(resolve => {
      //bloccato al primo caricamento con first
      tempManagerRef.snapshotChanges().first().subscribe(onmanager => {

        this.usersManager = [];

        let tempUser: User;

        for (let user of onmanager) {
          tempUser = {
            key: user.key,
            enabled: user.payload.val().enabled,
            name: user.payload.val().name,
            email: user.payload.val().email,
            id: user.payload.val().id,
            notification: user.payload.val().notification,
            photo: user.payload.val().photo,
            role: user.payload.val().role,
            title: user.payload.val().title,
            canSeeLeaveTravel: user.payload.val().canSeeLeaveTravel
          }

          if (tempUser.enabled) {
            this.usersManager.push(tempUser);
          }

        }

        resolve(this.usersManager);
      });
    });

  }

  getAreaManager(): Promise<User[]> {
    let tempAreaManagerRef = this.adb.list(usersEndpointRoot + usersEndpoint.areamanager);

    return new Promise(resolve => {
      //bloccato al primo caricamento con first
      tempAreaManagerRef.snapshotChanges().first().subscribe(onareamanager => {

        this.usersAreaManager = [];

        let tempUser: User;

        for (let user of onareamanager) {
          tempUser = {
            key: user.key,
            enabled: user.payload.val().enabled,
            name: user.payload.val().name,
            email: user.payload.val().email,
            id: user.payload.val().id,
            notification: user.payload.val().notification,
            photo: user.payload.val().photo,
            role: user.payload.val().role,
            title: user.payload.val().title,
            uid: user.payload.val().uid,
            canSeeLeaveTravel: user.payload.val().canSeeLeaveTravel
          }

          if (tempUser.enabled) {
            this.usersAreaManager.push(tempUser);
          }

        }
        //console.log(this.usersAreaManager);
        resolve(this.usersAreaManager);
      });
    });

  }

  getAreaManager_Manager(): Promise<User[]> {
    let tempAreaManagerRef = this.adb.list(usersEndpointRoot + usersEndpoint.areamanager_manager);

    return new Promise(resolve => {
      //bloccato al primo caricamento con first
      tempAreaManagerRef.snapshotChanges().first().subscribe(onareamanager => {

        this.usersAreaManager_Manager = [];

        let tempUser: User;

        for (let user of onareamanager) {
          tempUser = {
            key: user.key,
            enabled: user.payload.val().enabled,
            name: user.payload.val().name,
            email: user.payload.val().email,
            id: user.payload.val().id,
            notification: user.payload.val().notification,
            photo: user.payload.val().photo,
            role: user.payload.val().role,
            title: user.payload.val().title,
            uid: user.payload.val().uid,
            canSeeLeaveTravel: user.payload.val().canSeeLeaveTravel
          }

          if (tempUser.enabled) {
            this.usersAreaManager_Manager.push(tempUser);
          }

        }
        //console.log(this.usersAreaManager_Manager);
        resolve(this.usersAreaManager_Manager);
      });
    });

  }

  getADuser(): Promise<User[]> {
    let tempADRef = this.adb.list(usersEndpointRoot + usersEndpoint.ad);

    return new Promise(resolve => {
      //bloccato al primo caricamento con first
      tempADRef.snapshotChanges().first().subscribe(ADs => {

        // //console.log(onAD);

        this.userAD = [];

        let tempUser: User;

        for (let user of ADs) {
          tempUser = {
            key: user.key,
            enabled: user.payload.val().enabled,
            name: user.payload.val().name,
            email: user.payload.val().email,
            id: user.payload.val().id,
            notification: user.payload.val().notification,
            photo: user.payload.val().photo,
            role: user.payload.val().role,
            title: user.payload.val().title,
            uid: user.payload.val().uid,
            canSeeLeaveTravel: user.payload.val().canSeeLeaveTravel
          }

          if (tempUser.enabled) {
            this.userAD.push(tempUser);
          }

        }

        //console.log(this.userAD);
        //console.log(this.usersAreaManager_Manager);
        resolve(this.userAD);

      });


    });
  }

  getReadOnlyAccess() {

  }

}



// WEBPACK FOOTER //
// ./src/providers/firebase-service/firebase-service.ts